<template>
  <div>
    <div class="text-left">All Blogs</div>

    <v-row class="mb-5" justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!guest"
            @click="clearForm"
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Create Blog
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span v-if="status == 'submit'" class="text-h5">Add New Blog</span>
            <span v-else-if="status == 'update'" class="text-h5"
              >Update Blog</span
            >
            <span v-else-if="status == 'upload'" class="text-h5"
              >Upload Picture Blog</span
            >
          </v-card-title>
          <v-form>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <label for="title">Blog Title</label>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                    v-if="status != 'upload'"
                    id="title"
                    v-model="title"
                    outlined
                    dense
                    label="Blog Title*"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-else
                    id="title"
                    v-model="title"
                    outlined
                    dense
                    label="Blog Title*"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <label for="description">Blog description</label>
                </v-col>
                <v-col cols="12" md="9">
                  <v-textarea
                    v-if="status != 'upload'"
                    id="description"
                    v-model="description"
                    outlined
                    dense
                    label="Blog Title*"
                    required
                  ></v-textarea>
                  <v-textarea
                    v-else
                    id="description"
                    v-model="description"
                    outlined
                    dense
                    label="Blog Title*"
                    readonly
                  ></v-textarea>
                  <small>*indicates required field</small>
                </v-col>
                <v-col cols="12" md="3" v-if="status == 'upload'">
                  <label for="upload">Upload Picture</label>
                </v-col>
                <v-col md="9" v-if="status == 'upload'" cols="12">
                  <input type="file" name="photo" ref="photo" />
                </v-col>
                <v-col offset-md="3" cols="12">
                  <v-btn
                    v-if="status == 'submit'"
                    color="primary"
                    @click="submitForm()"
                  >
                    Create
                  </v-btn>
                  <v-btn
                    v-else-if="status == 'update'"
                    color="primary"
                    @click="updateBlog(idEditBlog)"
                  >
                    Update
                  </v-btn>
                  <v-btn
                    v-else-if="status == 'upload'"
                    color="primary"
                    @click="submitPhoto(idEditBlog)"
                  >
                    Upload
                  </v-btn>
                  <v-btn
                    type="reset"
                    class="mx-2"
                    outlined
                    @click="dialog = false"
                  >
                    Close
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>

    <v-layout wrap>
      <blog-item-component
        v-for="blog in blogs"
        :key="blog.id"
        :blog="blog"
        :edit="guest"
        v-on:edit="editBlog($event)"
        v-on:delete="deleteBlog($event)"
        v-on:upload="uploadBlog($event)"
      ></blog-item-component>
    </v-layout>
    <div class="text-center">
      <v-pagination
        v-model="page"
        @input="go"
        :length="lengthPage"
        :total-visible="perPage"
        circle
      ></v-pagination>
    </div>
  </div>
  <!-- <v-container class="ma-0 pa-0" grid-list-sm>
    </v-container> -->
</template>

<script>
import { mapGetters } from "vuex";
import BlogsItemComponent from "../components/BlogsItemComponent.vue";

export default {
  data: () => ({
    title: "",
    description: "",
    photo: "",
    status: "submit",
    idEditBlog: "",
    apiDomain: "https://demo-api-vue.sanbercloud.com",
    blogs: [],
    page: 0,
    lengthPage: 0,
    perPage: 0,
    dialog: false,
    edit: false,
    delblog: "",
  }),

  computed: {
    ...mapGetters({
      guest: "auth/guest",
    }),
  },

  components: {
    "blog-item-component": BlogsItemComponent,
  },
  methods: {
    go() {
      const config = {
        method: "get",
        url: this.apiDomain + "/api/v2/blog",
        params: { page: this.page },
      };
      this.axios(config)
        .then((response) => {
          let { blogs } = response.data;
          this.blogs = blogs.data;
          this.page = blogs.current_page;
          this.lengthPage = blogs.last_page;
          this.perPage = blogs.per_page;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    clearForm: function () {
      this.title = "";
      this.description = "";
      this.photo = "";
      this.status = "submit";
      this.idEditBlog = null;
      this.dialog = false;
    },

    submitForm: function () {
      // let file = this.$refs.photo.files[0]

      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("description", this.description);
      // formData.append('photo', file)

      const config = {
        method: "post",
        url: this.apiDomain + "/api/blog",
        data: formData,
      };

      this.axios(config)
        .then((response) => {
          this.clearForm();
          this.go();
          console.log(response);
          alert("Create Blog Successfully");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    editBlog: function (blog) {
      this.title = blog.title;
      this.description = blog.description;
      this.status = "update";
      this.idEditBlog = blog.id;
      this.dialog = true;
    },

    updateBlog: function (idEditBlog) {
      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("description", this.description);
      // formData.append('photo', file)

      const config = {
        method: "post",
        url: `${this.apiDomain}/api/blog/${idEditBlog}`,
        params: { _method: "PUT" },
        data: formData,
      };
      console.log(formData);

      this.axios(config)
        .then((response) => {
          this.go();
          this.clearForm();
          console.log(response);
          alert("Update Blog Successfully");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteBlog: function (blog) {
      this.delblog = confirm("Delete this Blog " + blog.title + "?");
      if (this.delblog) {
        const config = {
          method: "post",
          url: `${this.apiDomain}/api/blog/${blog.id}`,
          params: { _method: "DELETE" },
        };

        this.axios(config)
          .then((response) => {
            this.go();
            console.log(response);
            alert("Delete Blog Successfully");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    uploadBlog: function (blog) {
      this.title = blog.title;
      this.description = blog.description;
      this.status = "upload";
      this.idEditBlog = blog.id;
      this.dialog = true;
    },

    submitPhoto: function (idEditBlog) {
      let file = this.$refs.photo.files[0];
      let formData = new FormData();
      formData.append("photo", file);
      console.log(formData);
      const config = {
        method: "post",
        url: `https://demo-api-vue.sanbercloud.com/api/blog/${idEditBlog}/upload-photo`,
        data: formData,
      };
      this.axios(config)
        .then((response) => {
          this.clearForm();
          this.go();
          console.log(response);
          alert("Upload Pict Blog Successfully");
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  created() {
    this.go();
  },
};
</script>